import { FC } from 'react'

import shortenAddress from '@ambire-common/utils/shortenAddress'
import { isMobileWebApp } from '@common/config/env'
import Text from '@common/components/Text'
import useWindowSize from '@common/hooks/useWindowSize'
import spacings from '@common/styles/spacings'
import formatShortAddress from '@common/utils/formatShortAddress'

// Below the tablet breakpoint the mobile-web layout is a phone-width column with
// no room for a full address, so it collapses to the compact `0x1234...abcd`
// form. At/above it (tablet + desktop) there's space to show the full address.
const FULL_ADDRESS_MIN_WIDTH = 768

interface Props {
  maxLength: number
  address: string
  style?: any
  hideParentheses?: boolean
  fontSize?: number
}

const PlainAddress: FC<Props> = ({ style, maxLength, address, hideParentheses, fontSize = 12 }) => {
  const { maxWidthSize } = useWindowSize()
  // Only the narrow mobile-web layout collapses to the compact form; the
  // extension popup and wider tablet/desktop layouts keep the full address.
  const useShortForm = isMobileWebApp && !maxWidthSize(FULL_ADDRESS_MIN_WIDTH)

  return (
    <Text
      fontSize={fontSize}
      appearance="secondaryText"
      numberOfLines={1}
      ellipsizeMode="middle"
      style={[spacings.mrMi, { flexShrink: 1, minWidth: 0 }, style]}
    >
      {hideParentheses ? '' : '('}
      {useShortForm ? formatShortAddress(address) : shortenAddress(address, maxLength)}
      {hideParentheses ? '' : ')'}
    </Text>
  )
}

export default PlainAddress
